export default "../css/fef6a6d5d1c413a61d86a9b0d6d27eac.otf";